<template>
  <div class="flex flex-col w-full overflow-hidden">
    <div class="w-full h-full flex-grow overflow-y-auto" @scroll="handleScroll">
      <div class="w-full max-w-content mx-auto">
        <div class="h-10" ref="spacer"></div>
        <base-back-button />
        <div class="px-4 sm:px-0">
          <h2 class="font-sans text-2xl uppercase mb-1" ref="pageTitle">{{ pageTitle }}</h2>
          <h3 class="text-neutral mb-2">Se ha producido un error.</h3>
          <base-message-box>
            <template slot="content">
              <p>Se ha producido un error en el <strong>proceso de la fotografía</strong>. Para continuar con la activación del reconocimiento facial ha de repetir el proceso.</p>
            </template>
          </base-message-box>

          <base-button mode="primary" custom="w-full my-4" text="Repetir el proceso de configuración" @click="reset" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleScrollMixin } from '@/mixins/appMixin'

export default {
  name: 'BiometricConfig',
  mixins: [handleScrollMixin],
  data: function () {
    return {}
  },
  computed: {
    pageTitle: function () {
      return this.$route?.meta?.title
    }
  },
  methods: {
    reset: function () {
      this.$emit('reset')
    }
  }
}
</script>

<style lang="scss" scoped></style>
